"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_ACTIONS = void 0;
var THEME_ACTIONS;
(function (THEME_ACTIONS) {
    THEME_ACTIONS["LOADED_SET"] = "@hopin/theme-provider/loaded-set";
    THEME_ACTIONS["CUSTOM_THEME_SET"] = "@hopin/theme-provider/custom-theme-set";
    THEME_ACTIONS["CUSTOM_FONT_SET"] = "@hopin/theme-provider/custom-font-set";
})(THEME_ACTIONS = exports.THEME_ACTIONS || (exports.THEME_ACTIONS = {}));
//# sourceMappingURL=themeActions.js.map